// eslint-disable-next-line no-unused-vars
import { PlayerModalState } from '../types';
import '../../types';

/**
 * @param {PlayerModalState} draft - Draft state.
 * @param {object} payload - Action payload.
 * @param {boolean} payload.visible - Whether the modal is visible.
 * @param {string} payload.playerId - The ID of the player.
 * @param {string} payload.seasonPid - The season ID.
 * @param {object} payload.leaderBoardData - The leaderboard data.
 * @param {string} payload.seasonId - The season ID.
 * @param {object} payload.player - The player data.
 * @param {boolean} payload.shouldHidePredicted - Whether to hide predicted votes.
 * @param {boolean} payload.isPredictor - Whether the we open the predictor.
 * @param {string} payload.modifier - The modifier.
 */
export const setPlayerModal = (draft, payload) => {
    Object.assign(draft, payload);
};
